// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Star: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 40" enableBackground="new 0 0 42 40" xmlSpace="preserve" fill="currentColor">
<path fillRule="evenodd" clipRule="evenodd" d="M41.27,15.19c-0.17-0.53-0.67-0.89-1.23-0.89l-14.15,0l-4-13.41
	C21.72,0.36,21.22,0,20.67,0c-0.56,0-1.05,0.36-1.23,0.88l-3.86,13.41l-14.29,0c-0.56,0-1.06,0.36-1.23,0.89
	c-0.17,0.53,0.02,1.12,0.47,1.44l12,8.54l-4.77,13.5c-0.18,0.53,0.11,0.9,0.44,1.11c0.33,0.21,1.08,0.05,1.3-0.11l11.16-8.3
	l11.7,8.42c0.23,0.16,0.83,0.35,1.26-0.01c0.43-0.36,0.44-0.69,0.26-1.22l-4.73-13.43l11.63-8.52
	C41.25,16.3,41.44,15.72,41.27,15.19z"/>
</svg>;
};

export default React.memo(Star);
